module.exports = __webpack_public_path__ + "img/07.a6c149d0.png";